import React, { useState } from 'react';
import {
  Box,
  VStack,
  HStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  Heading,
  Text,
  useToast,
  InputGroup,
  InputRightElement,
  IconButton,
  Card,
  CardBody,
} from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../utils/api';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await authAPI.login(username, password);
      
      login(response);
      
      toast({
        title: 'Connexion réussie',
        description: `Bienvenue ${response.name}!`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Login error:', error);
      const errorMessage = error.response?.data?.message || 'Erreur de connexion';
      toast({
        title: 'Erreur de connexion',
        description: errorMessage,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={4}
      bg="gray.50"
      _dark={{ bg: 'gray.900' }}
    >
      <Card
        w="full"
        maxW="400px"
        shadow="lg"
        bg="white"
        _dark={{ bg: 'gray.800' }}
      >
        <CardBody p={8}>
          <VStack spacing={6} as="form" onSubmit={handleSubmit}>
            <VStack spacing={2} textAlign="center">
              <Heading size="lg" color="brand.500">
                Déclaration Commerciale
              </Heading>
              <Text color="gray.600" _dark={{ color: 'gray.400' }}>
                Connectez-vous à votre compte
              </Text>
            </VStack>

            <FormControl isRequired>
              <FormLabel>Nom d'utilisateur</FormLabel>
              <Input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Entrez votre nom d'utilisateur"
                size="lg"
                bg="white"
                _dark={{ bg: 'gray.700' }}
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Mot de passe</FormLabel>
              <InputGroup>
                <Input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Entrez votre mot de passe"
                  bg="white"
                  _dark={{ bg: 'gray.700' }}
                />
                <InputRightElement>
                  <IconButton
                    icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                    onClick={() => setShowPassword(!showPassword)}
                    variant="ghost"
                    size="sm"
                    aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                  />
                </InputRightElement>
              </InputGroup>
            </FormControl>

            <Button
              type="submit"
              colorScheme="brand"
              size="lg"
              w="full"
              isLoading={loading}
              loadingText="Connexion..."
            >
              Se connecter
            </Button>

            {/* Demo credentials */}
            <Box
              p={4}
              bg="blue.50"
              _dark={{ bg: 'blue.900' }}
              borderRadius="md"
              w="full"
            >
              <Text fontSize="sm" color="blue.700" _dark={{ color: 'blue.200' }}>
                <strong>Note:</strong> Utilisez vos identifiants de base de données
              </Text>
            </Box>
          </VStack>
        </CardBody>
      </Card>
    </Box>
  );
};

export default Login; 